/**
 * Validate HTTP header field names according to RFC 7230 specifications.
 * @param val The header field name to validate.
 * @returns True if the header field name is valid, false otherwise.
 *
 * @description HTTP header field names must follow RFC 7230 specifications
 *  - Must not be empty
 *  - Can contain: letters, digits, hyphens
 *  - Must start with a letter or digit
 *  - Cannot contain spaces, underscores, or special characters except hyphens
 *  - Common headers like Content-Type, Authorization, X-Custom-Header are valid
 */
export function validateHeaderKey(val: string): boolean {
  if (!val || val.length === 0) return false;
  // RFC 7230: field-name = token
  // token = 1*tchar
  // tchar = "!" / "#" / "$" / "%" / "&" / "'" / "*" / "+" / "-" / "." /
  //         "^" / "_" / "`" / "|" / "~" / DIGIT / ALPHA
  const httpHeaderRegex = /^[a-zA-Z0-9!#$%&'*+\-.^_`|~]+$/;
  return httpHeaderRegex.test(val);
}
